import LinkTransition from "../common/link-transition"
import PropTypes from "prop-types"
import React, { useState, createRef, useEffect } from "react"

import SocialIcons from "../social-icons"

import {
  FooterContainer,
  Container,
  Content,
  FooterBottom,
  Col,
  Intro,
  List,
  FooterItem,
  Newsletter,
} from "./styled"
import Logo from "../common/logo"

const Footer = ({ siteTitle }) => {
  let newsletterFormEl = createRef()

  const [newsletterFormAdded, setNewsletterFormAdded] = useState(false)

  useEffect(() => {
    if (!newsletterFormAdded && window) {
      // addScript(newsletterFormEl.current)
    }
  }, [])

  const addScript = el => {
    const scriptExternal = document.createElement("script")
    scriptExternal.src = "//js.hsforms.net/forms/v2.js"
    el.appendChild(scriptExternal)

    if (window.hbspt && el) {
      addNewsletterForm(el)
    } else {
      setTimeout(() => {
        addScript(el)
      }, 0)
    }
  }

  const addNewsletterForm = el => {
    setTimeout(() => {
      const scriptCode = document.createElement("script")
      scriptCode.innerHTML = `
      window.hbspt.forms.create({
        portalId: "7066418",
	      formId: "2b74aa4c-b9fd-44dd-8c5a-0e90de5106b0"
      });
      `
      el.appendChild(scriptCode)
      setNewsletterFormAdded(true)
    }, 0)
  }

  return (
    <FooterContainer>
      <Container>
        <Content>
          <Col width="2">
            <Intro>
              <h2 className="title">
                Collaborative presentations
                <br />
                for creative teams
              </h2>
            </Intro>
          </Col>

          <Col width="2.5" className="middle">
            <List>
              <FooterItem>
                <LinkTransition to="/">Home</LinkTransition>
              </FooterItem>
              <FooterItem>
                <LinkTransition to="/product-tour">Product tour</LinkTransition>
              </FooterItem>
              <FooterItem>
                <a href="https://blog.ludus.one/">Blog</a>
              </FooterItem>
              <FooterItem>
                <LinkTransition to="/pricing">Pricing</LinkTransition>
              </FooterItem>
              <FooterItem>
                <LinkTransition to="/education">Education</LinkTransition>
              </FooterItem>
              {/* <FooterItem>
              <LinkTransition to="/startups">
                Startups 
              </LinkTransition>
            </FooterItem> */}
            </List>
            <List>
              <FooterItem>
                <LinkTransition to="/about">About us</LinkTransition>
              </FooterItem>
              <FooterItem>
                <a
                  href="https://help.ludus.one/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Help & documentation
                </a>
              </FooterItem>
              <FooterItem>
                <a
                  href="https://ludus.kampsite.co/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Roadmap
                </a>
              </FooterItem>
              <FooterItem>
                <a
                  href="https://headwayapp.co/ludus-changelog"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Changelog
                </a>
              </FooterItem>
              <FooterItem>
                <LinkTransition to="/contact">Contact us</LinkTransition>
              </FooterItem>
            </List>
          </Col>

          <Col width="2">
            {/* <Newsletter>
              <h3 className="title">
                Because we love sending tips and surprises.
              </h3>
              <div ref={newsletterFormEl} />
            </Newsletter> */}

            <SocialIcons footer={true} dark={true}>
              <h4>Follow us 👇</h4>
            </SocialIcons>
          </Col>
        </Content>

        <FooterBottom>
          <LinkTransition
            to="/"
            style={{
              color: `white`,
              textDecoration: `none`,
            }}
          >
            <span className="accessibility-hidden">
              Go to homepage of Ludus
            </span>
            <Logo styleType="fullWhite" />
          </LinkTransition>

          <ul>
            <li>
              <LinkTransition to="/terms-and-conditions">
                Terms and Conditions
              </LinkTransition>
            </li>
            <li>
              <LinkTransition to="/privacy-policy">
                Privacy Policy
              </LinkTransition>
            </li>
            <li style={{ marginRight: "50px" }}>
              Copyright © Ludus N, Inc. {new Date().getFullYear()}
            </li>
          </ul>
        </FooterBottom>
      </Container>
    </FooterContainer>
  )
}

Footer.propTypes = {
  siteTitle: PropTypes.string,
}

Footer.defaultProps = {
  siteTitle: ``,
}

export default Footer
